export var getSnackBarsList = function (state) { return state.snackBar.list; };
//# sourceMappingURL=snacks.js.map